module.exports = __webpack_public_path__ + "static/media/icon-link.5614033a.svg";